export interface IHierarchyConfig {
  masterKeyApiUrl: string;
  isAlohomora: boolean;
}

const ApiVersion = 'v1.0';

export class HierarchyConfig {
  private readonly _masterKeyApiUrl: string;
  private readonly _isAlohomora: boolean;

  private constructor(masterKeyApiUrl: string, isAlohomora: boolean) {
    this._masterKeyApiUrl = masterKeyApiUrl;
    this._isAlohomora = isAlohomora;
  }

  public static createConfig(configProps: IHierarchyConfig): HierarchyConfig {
    if (!configProps.masterKeyApiUrl) {
      throw new Error(`KeyingHierarchyConfig cannot be created.`);
    }

    return new HierarchyConfig(configProps.masterKeyApiUrl, configProps.isAlohomora);
  }

  public getKeyingUrl(): string {
    if (!this._isAlohomora) {
      return `${this._masterKeyApiUrl}/v1.0`;
    }

    return `${this._masterKeyApiUrl}/v1.0`;
  }

  get baseUrl(): string {
    return `${this._masterKeyApiUrl}/${ApiVersion}`;
  }
}
